// hooks/team/useMonthlyProductivity.js
import { useQuery } from '@tanstack/react-query';
import apiService from '../../services/api';
import { ENDPOINTS } from '../../services/endpoints';

const monthlyProductivityQueryDefaults = {
  staleTime: 1000 * 60 * 10,    // 10 minutes (trends change less frequently)
  gcTime: 1000 * 60 * 60,       // 1 hour cache
  retry: 2,
  retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
};

export const useMonthlyProductivity = (startDate, endDate) => {
  const {
    data: monthlyTrends,
    isLoading,
    isFetching,
    isError,
    error,
    refetch,
  } = useQuery({
    queryKey: ['monthlyProductivity', startDate, endDate],
    queryFn: async () => {
      const startTime = performance.now();
      
      const response = await apiService.get(ENDPOINTS.TIME_MONTHLY_PRODUCTIVITY, {
        start_date: startDate,
        end_date: endDate
      });
      
      // console.log(`Monthly productivity loaded in ${(performance.now() - startTime).toFixed(0)}ms`);
      
      return response;
    },
    enabled: !!(startDate && endDate),
    ...monthlyProductivityQueryDefaults,
  });

  return {
    // Data
    monthlyTrends,
    trendData: monthlyTrends || null,
    
    // Loading states
    loading: isLoading,
    refreshing: isFetching,
    
    // Error handling
    error: isError ? (error?.message || 'Failed to load monthly trends') : null,
    isError,
    
    // Status
    initialized: !!monthlyTrends,
    hasData: !!(startDate && endDate),
    
    // Actions
    refetch,
  };
};